import React, { FC } from "react";
import { useQuery } from "react-query";
import { makeStyles } from "@material-ui/core";
import useBranchQueries from "../../../../../school/hooks/useBranchQueries";
import { IWizardStepContent } from "../../../../../wizard/types";
import { parseToCreateProgramPreview } from "../../../../helpers/parseToCreateProgramPreview";
import { PreviewProgramSecondary } from "../../../components/step5/PreviewProgramSecondary";
import { useSchoolId } from "../../../../../school/hooks/useSchoolId";
import { QUERY_KEYS } from "../../../../../../constants";

const useStyles = makeStyles(() => ({
  mainContainer: {
    "& > div": {
      marginTop: 24,
    },
    "& > :first-child": {
      marginTop: "unset",
    },
  },
}));

const Content: FC<IWizardStepContent> = ({
  stepName,
  handleSubmit,
  ...formData
}) => {
  const classes = useStyles();

  const { branches: branchesQueryKey } = QUERY_KEYS;

  const schoolId = useSchoolId();
  const { fetchAll: fetchAllBranches } = useBranchQueries();
  const { data: branches } = useQuery<any>(branchesQueryKey, () =>
    fetchAllBranches({ schoolId }),
  );

  if (!branches) {
    return null;
  }

  const previewData = parseToCreateProgramPreview({
    programRawData: formData.values,
    branches: branches.data,
  });

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <PreviewProgramSecondary {...previewData} />
      </div>
    </form>
  );
};

export default Content;
